import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://lexfmpzdduzpdsbdquul.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxleGZtcHpkZHV6cGRzYmRxdXVsIiwicm9sZSI6ImFub24iLCJpYXQiOjE2Njk0MzQ2MzEsImV4cCI6MTk4NTAxMDYzMX0.Kedx6uwzv1lWjAw4CyesLdAoEYbUrLnNdW6HK-pFpic";
export const supabase = createClient(supabaseUrl, supabaseKey);
